/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  return {
    variables: { id: props.insuranceId },
  }
}
